import history from '../../../history';
import { setLoaderStart, setLoaderComplete } from '../../loader/loader';
import { showToaster } from '../../../helpers/toastrMessgaes/showToaster';
import { updateUserMutation as mutation, getAllUsers as query } from '../../../lib/graphql';

export const editUser = (values) => {
  return async (dispatch, getState, { client }) => {

    try {

      dispatch(setLoaderStart('EditUser'));

      const { data } = await client.mutate({
        mutation,
        variables: {
          id: values?.id,
          firstName: values?.firstName,
          lastName: values?.lastName,
          email: values?.email,
          phoneDialCode: values?.phoneDialCode,
          phoneNumber: values?.phoneNumber,
          userStatus: values?.userStatus,
          isBan: values?.isBan,
          phoneCountryCode: values?.phoneCountryCode,
          preferredCurrency: values?.preferredCurrency
        },
        refetchQueries: [{
          query,
          variables: {
            currentPage: 1,
            userType: 1
          }
        }]
      });

      if (data?.updateUser?.status === 200) {
        history.push('/siteadmin/users')
        showToaster({ messageId: 'updateUser', toasterType: 'success' });
      } else {
        showToaster({ messageId: 'errorMessage', requestContent: { content: data?.updateUser?.errorMessage }, toasterType: 'error' });
      }
      dispatch(setLoaderComplete('EditUser'));
    } catch (error) {
      dispatch(setLoaderComplete('EditUser'));
      showToaster({ messageId: 'catchMessage', requestContent: { content: err }, toasterType: 'error' });
    }
  }
}